'use strict';

var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')
var ReactDOM = require('react-dom');
var createReactClass = require('create-react-class');
// var RCTLog = require('RCTLog');
var Splash = require('./splash.js');
var AppNavigator = require('./appNavigator.js');
var appActions = require('./AppActions.js');
var featureBuilder = require('./FeatureBuilder.js');
var InterstitialContainer = require('./InterstitialContainer.js');
// var RNOverlay = require('./src/wrappers/react-native-overlay-wrapper.android.js');
// global.self = global; //DO NOT DELETE

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

var {
  AppRegistry,
  StyleSheet,
  Text,
  View,
  Navigator,
} = ReactNative;

var Animated = require('./wrappers/Animated');

var ReUp = createReactClass(
{
  getInitialState : function()
  {
    var shouldShowInterstitial = (findGetParameter("isPass") != "1") && (findGetParameter("isPassFree") != "1");
    return {
      shouldShowSplash : true,
      shouldShowApp : false,
      shouldShowInterstitial,

      appManager : null,
      splashOpacity : new Animated.Value(1),
      interstitialOpacity : new Animated.Value(0),
    }
  },

  componentDidMount : function()
  {
    var styleElement = document.getElementById('react-native-stylesheet');
    // if not, inject the style sheet
    if (styleElement)
    {
      // styleElement.innerHTML = "div{padding:0px}"
    }
    document.head.insertAdjacentHTML(
        'beforeend',
        `<style id="custom">:focus { outline: 0; } div{padding:0px; padding-top:0px; padding-bottom:0px; padding-left:0px; padding-right:0px; margin:0px; overflow:none;}</style>`
      );
  },

  _shouldSkipInterstitial : false,
  splashDidFinish : function(appManager) {
    var thisThing = this;
    if( this._cacheIndex != null ) appManager._imageCacheIndex = this._cacheIndex;
    // appManager.setAvailableFonts(this.props.availableFonts);
    appManager.getVariable(appManager.TUTORIAL_LAST_VIEWED, function(date)
    {
      thisThing.setState({appManager : appManager});
      thisThing._shouldSkipInterstitial = true;//thisThing._shouldSkipInterstitial || (typeof thisThing.state.appManager.getFeatureForName('DomainLogin') !== 'undefined') || (typeof date !== 'undefined' && date != null) || (typeof thisThing.props.SKIP_TUTORIAL === 'undefined' ? false : (thisThing.props.SKIP_TUTORIAL == "YES"));

      var thisThingThing = thisThing;
      if( thisThing._shouldSkipInterstitial )
      {
        thisThing.setState({shouldShowApp : true});
        Animated.timing(
        thisThing.state.splashOpacity,
        {
          toValue: 0,
          duration:150
        },
        ).start(function()
        {
          thisThing.setState({shouldShowSplash : false, shouldShowInterstitial:false});
        });
      }
      else
      {
        thisThing.setState({shouldShowInterstitial : true});
        setTimeout(function()
        {
          Animated.timing(
          thisThing.state.interstitialOpacity,
          {
            toValue: 1,
            duration:150
          },
          ).start(function()
          {
          });
        }, 1000) // give the first image a sec to load
      }
    })
  },

  interstitialDidFinish : function(completion)
  {
    this.setState({shouldShowApp:true});
    if( typeof completion !== 'undefined' ) this.setState({appLoadCompletion:completion});

    var thisThing = this;
    Animated.timing(
    thisThing.state.interstitialOpacity,
    {
      toValue: 0,
      duration:300
    },
    ).start(function()
    {
      thisThing.setState({shouldShowInterstitial:false, shouldShowSplash:false});
    });

    Animated.timing(
    thisThing.state.splashOpacity,
    {
      toValue: 0,
      duration:300
    },
    ).start(function()
    {
    });
  },

  _cacheIndex : null,
  restartApp : function()
  {
    this._cacheIndex = (new Date()).getTime();
  	this.setState({shouldShowSplash:true, shouldHideSplash:false, shouldShowInterstitial:false, shouldShowApp:false});
  },

  render: function()
  {
    return (
  		<View style={{flex:1, alignSelf:'stretch', height:'100%', width:'100%', maxWidth:'100%', overflow:'hidden', flexDirection:'column'}}>
        {
          (this.state.shouldShowApp)?
            <View style={{flex:1, alignSelf:'stretch'}}>
              <AppNavigator key="appNav" appManager={this.state.appManager} restartApp={this.restartApp} appLoadCompletion={this.state.appLoadCompletion} />
            </View>
          : null
        }
  			{
  				this.state.shouldShowSplash ?
    				<Animated.View ref={"splashContainer"} key={"splashContainer"} style={{position:'absolute', top:0, left:0, right:0, bottom:0, flexDirection:'column', opacity:this.state.splashOpacity, flex:-1 }} layout={this.props.layout}>
    		    	<Splash splashDidFinish={this.splashDidFinish} />
    		    </Animated.View>
  				:	null
  			}
        {
          this.state.shouldShowInterstitial && this.state.appManager != null && typeof this.state.appManager.getFeatureForName('DomainLogin') === 'undefined' ?
    				<Animated.View style={{position:'absolute', top:0, left:0, right:0, bottom:0, flexDirection:'column', opacity:this.state.interstitialOpacity, flex:-1}}>
              <InterstitialContainer key="appNav" appManager={this.state.appManager} appActions={this.state.appActions} featureBuilder={featureBuilder} interstitialDidFinish={this.interstitialDidFinish} />
            </Animated.View>
          : null
        }
  		</View>
		)
  }
});

var styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5FCFF',
  },
  welcome: {
    fontSize: 20,
    textAlign: 'center',
    margin: 10,
  },
  instructions: {
    textAlign: 'center',
    color: '#333333',
    marginBottom: 5,
  },
});
ReactDOM.render(<ReUp />, document.getElementById("root"));
// AppRegistry.registerComponent('ReUp', () => ReUp);



// WEBPACK FOOTER //
// ./src/index.js